
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import EditDocumentsViewModel from "@/models/documents/editDocumentsViewModel";
import CustomVueEditor from "@components/inputs/CustomVueEditorComponent.vue";
import DocumentTypeEnum from "@/api/dataSource/api/Spirit/Entities/Enums/DocumentTypeEnum";

@Component({
  components: { CustomVueEditor },
})
export default class PageEditDocumentComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  vm: EditDocumentsViewModel = new EditDocumentsViewModel();
  get id(): DocumentTypeEnum {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.initLanguages(this.languages);
    if (DocumentTypeEnum) {
      await this.fetchData();
    }
  }
  async fetchData() {
    const res = await this.$api.DocumentService.getDocumentByIdAsync(this.id);
    this.vm.fromServerModel(res);
  }
  save() {
    if (!(this.$refs.translationTabs as any).isValid()) return;
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) {
      return;
    }
    this.isLoading = true;
    const req = this.vm.toServerModel();
    this.$api.DocumentService.updateAsync(req);
    this.isLoading = false;
    this.$notification.success("Документ успешно обновлен");
    this.$router.back();
  }
}
